import React from 'react';
import { Snackbar } from 'material-ui';
import { connect } from 'react-redux';
import { UI_ACTIONS } from 'dash-front/reducers/ui';

export const closeSnackBar = dispatch => {
    dispatch({ type: UI_ACTIONS.CHANGE, key: 'snackbarOpen', value: false });
    dispatch({ type: UI_ACTIONS.CHANGE, key: 'snackbarText', value: null });
};
let timer;
export const showSnackBarMessage = (message, time = 3000) => dispatch => {
    clearTimeout(timer);
    dispatch({ type: UI_ACTIONS.CHANGE, key: 'snackbarText', value: message });
    dispatch({ type: UI_ACTIONS.CHANGE, key: 'snackbarOpen', value: true });
    if (Number.isFinite(time)) {
        timer = setTimeout(() => {
            dispatch(closeSnackBar);
        }, time);
    }
};

export const GlobalSnackBar = connect(({ ui }) => ({
    open: Boolean(ui.snackbarOpen),
    text: ui.snackbarText || ''
}))(({ open, text }) => <Snackbar open={open} message={text} />);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/GlobalSnackbar.js
 **/